import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../../styles/common/imagePreviewPopup.scss";

const ImagePreviewPopup = ({
  isOpen,
  onClose,
  imageUrl,
  imageName,
  imageId,
  imageFileName,
}) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [copyFileNameSuccess, setCopyFileNameSuccess] = useState(false);

  if (!isOpen) return null;

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(imageUrl);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error("Failed to copy URL:", err);
    }
  };

  const handleCopyFileName = async () => {
    try {
      await navigator.clipboard.writeText(imageFileName || imageName);
      setCopyFileNameSuccess(true);
      setTimeout(() => setCopyFileNameSuccess(false), 2000);
    } catch (err) {
      console.error("Failed to copy file name:", err);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div className="image-preview-overlay" onClick={handleBackdropClick}>
      <div className="image-preview-modal">
        <div className="image-preview-header">
          <h3 className="image-preview-title">
            {imageName || "Image Preview"}
          </h3>
          <div className="image-preview-close-div">
            <button
              className={`image-preview-copy-btn ${copySuccess ? "success" : ""}`}
              onClick={handleCopyUrl}
            >
              {copySuccess ? "Copied Image Url!" : "Copy Image Url"}
            </button>
            <button className="image-preview-close" onClick={onClose}>
              ×
            </button>
          </div>
        </div>

        <div className="image-preview-content">
          <div className="image-preview-image-container">
            <img
              src={imageUrl}
              alt={imageName || "Preview"}
              className="image-preview-image"
              onError={(e) => {
                e.target.src = "/placeholder-image.png";
              }}
            />
          </div>

          {/* <div className="image-preview-details">
            <div className="image-preview-detail-item">
              <div className="image-preview-detail-label">Image URL:</div>
              <div className="image-preview-detail-container">
                <input
                  type="text"
                  value={imageUrl}
                  readOnly
                  className="image-preview-detail-input"
                />
                <button
                  className={`image-preview-copy-btn ${copySuccess ? "success" : ""}`}
                  onClick={handleCopyUrl}
                >
                  {copySuccess ? " Copied!" : " Copy"}
                </button>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ImagePreviewPopup;
